
import { computed, defineComponent, onMounted } from "vue";
import { useStore } from "vuex";
import "element-plus/theme-chalk/display.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import { useRouter } from "vue-router";
export default defineComponent({
  setup() {
    const store = useStore();
    const router = useRouter();
    store.dispatch("user/getFeaturesAccess", "rooming");
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });
    function goTo(to, hotel) {
      router.push({ name: to, params: { hotelID: hotel } });
    }
    return { eventData, goTo };
  },
});
